import { DatoInvalido } from "../interfaces/merlin/datoInvalido.interface";
import { Duda } from "../interfaces/merlin/duda.interface";
import { DireccionNormalizadaMerlin } from "../interfaces/merlin/direccionNormalizada.interface";

export class ResponseMerlin {
    status?: string;
    direccionNormalizada?: DireccionNormalizadaMerlin;
    datoInvalido?: DatoInvalido = {} as DatoInvalido;
    opciones?: Duda[];
}

export class ResponseBusquedaPredictiva {
    pais: string;
    provincia: string;
    localidad: string;
    barrio: string;
    calle: string;
    cp: string;
    latitud: string;
    longitud: string;
    direccionCompleta: string;
}
